/**
 * Asynchronously fetches cart items from the server.
 * @returns {Object} The cart object containing cart items.
 * @throws Will throw an error if the network response is not ok.
 */
async function getCartItems() {
  try {
    const res = await fetch('/cart.js');
    if (!res.ok) {
      throw new Error('Network response was not ok: ' + res.statusText);
    }
    const cart = await res.json();
    return cart;
  } catch (error) {
    console.log('Error getting cart items', error);
  }
}

/**
 * Closes the modal and removes relevant classes from elements.
 * @param {HTMLElement} bodyElement - The body element.
 * @param {HTMLElement} modalContainer - The modal container element.
 */
function closeModal(bodyElement, modalContainer) {
  modalContainer.classList.remove('is-open');
  bodyElement.classList.remove('no-scroll--no-height');
}

/**
 * Sets up the popup cart with event listeners for closing the modal.
 * @param {HTMLElement} bodyElement - The body element.
 * @param {HTMLElement} modalContainer - The modal container element.
 */
function settingsPopUpCart(bodyElement, modalContainer) {
  const closeModalButtons = document.querySelectorAll('.btn-modal-home-close');

  closeModalButtons.forEach(button => {
    button.addEventListener('click', () => {
      closeModal(bodyElement, modalContainer);
    });
  });

  modalContainer.addEventListener('click', (event) => {
    if (!event.target.closest('.modal-home-sidecart__wrapper')) {
      closeModal(bodyElement, modalContainer);
    }
  });
}

/**
 * Opens the modal and adds relevant classes to elements.
 * @param {HTMLElement} bodyElement - The body element.
 * @param {HTMLElement} modalContainer - The modal container element.
 */
function openModal(bodyElement, modalContainer) {
  modalContainer.classList.add('is-open');
  bodyElement.classList.add('no-scroll--no-height');
}

/**
 * Formats a numeric value as a string representing a money amount.
 * @param {number} value - The numeric value to be formatted as money.
 * @returns {string} A string representing the formatted money amount.
 */
function formatMoney(value) {
  const formattedPrice = value / 100;
  return formattedPrice.toLocaleString('en-US', { minimumFractionDigits: 2 });
}

function cartItemPriceHtml(item) {
  const unit = Number(item.price) || 0;
  const original = Number(item.original_price) || 0;
  if (window.theme && typeof theme.formatCatalogDiscountHtml === 'function') {
    return theme.formatCatalogDiscountHtml(unit, original > unit ? original : 0);
  }
  return `<p>$${formatMoney(unit)}</p>`;
}

function cartTotalHtml(cart) {
  if (window.theme && typeof theme.formatCartTotalHtml === 'function') {
    return theme.formatCartTotalHtml(cart);
  }
  return `$${formatMoney(cart.total_price)}`;
}

/**
 * Displays the cart items in the modal.
 * @param {Object} cart - The Shopify Ajax cart object.
 */
function displayCartItems(cart) {
  const items = cart.items || [];
  const quantityItemsDiv = document.querySelector('.modal-home-sidecart__header-text--quantity');
  const itemListContainer = document.querySelector('.modal-home-sidecart__content-list');
  const totalContainer = document.querySelector('.modal-home-sidecart__footer-price-total--price');

  if (quantityItemsDiv) {
    quantityItemsDiv.innerHTML = `( ${items.length} items )`;
  }

  itemListContainer.innerHTML = '';

  items.forEach(item => {
    const liItem = document.createElement('li');
    liItem.classList.add('modal-home-sidecart__content-list-item');
    liItem.innerHTML = `
      <div class='modal-home-sidecart__content-card'>
        <div class="modal-home-sidecart__content-card-item-img">
          <img class="modal-home-sidecart__content-card-item-img--imagen" src="${item.image}" alt="${item.title}">
        </div>
        <div class="modal-home-sidecart__content-card-item--info">
          <h3>${item.product_title}</h3>
          <p>${item.variant_options[0]}</p>
        </div>
        <div class="modal-home-sidecart__content-card-item--price">
          ${cartItemPriceHtml(item)}
        </div>
      </div>
    `;
    itemListContainer.appendChild(liItem);
  });

  totalContainer.innerHTML = cartTotalHtml(cart);
}

/**
 * Handles the display of the popup cart on the homepage.
 */
async function popUpCart() {
  if (window.location.pathname !== '/') return;
  const bodyElement = document.body;
  const modalContainerMain = document.querySelector('.modal-home-sidecart');

  settingsPopUpCart(bodyElement, modalContainerMain);

  try {
    const cart = await getCartItems();
    if (cart && cart.items.length > 0) {
      displayCartItems(cart);
      openModal(bodyElement, modalContainerMain);
    }
  } catch (error) {
    console.error('Error in popUpCart:', error);
  }
}

export default popUpCart;
